<template>
    <el-select :value="current" @input="$emit('input', $event)" placeholder="选择四级单位" :size="size" clearable filterable
        v-loading="loading" style="width:140px" :disabled="disabled">
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id" />
    </el-select>
</template>

<script>
export default {
    name: 'select-subsidiary-4',
    props: {
        value: {
            type: [String, Number, Object]
        },
        sjdw_id: {
            type: [String, Number],
            default: ''
        },
        size: {
            default: 'small'
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            loading: false,
            current: this.value,
            options: []
        }
    },
    watch: {
        value: {
            immediate: false,
            handler(val) {
                this.current = val
            }

        },
        current: {
            immediate: false,
            handler(newVal) {
                this.$emit('input', newVal)
            }
        },
        sjdw_id: {
            // immediate: true,
            handler(newVal) {
                this.getData()
            }
        }
    },
    methods: {
        async getData() {
            this.loading = true
            const hl = await this.$http.get(`/company/subsidiary?level=4&sjdw_id=${this.sjdw_id || ''}&page=1&pageSize=2000`)
            this.options = hl.data.data.records
            this.loading = false
        }
    },
    mounted() {
        this.getData()
    }
}
</script>

<style lang="scss" scoped></style>
